import { render, staticRenderFns } from "./AsientosLfpComponent.vue?vue&type=template&id=40361ecc"
import script from "./AsientosLfpComponent.vue?vue&type=script&lang=js"
export * from "./AsientosLfpComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports